var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserApproveCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 376,
    viewBox: "0 0 376 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376 188C376 291.828 291.828 376 188 376C84.1723 376 0 291.828 0 188C0 84.1723 84.1723 0 188 0C291.828 0 376 84.1723 376 188Z",
    fill: "#1F76FF",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.896 235C221.896 197.362 191.384 166.85 153.746 166.85C116.108 166.85 85.5959 197.362 85.5959 235V256.15H221.896V235Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.096 112.8C109.096 137.461 129.085 157.45 153.746 157.45C178.407 157.45 198.396 137.461 198.396 112.8V98.7C198.396 74.0391 178.407 54.05 153.746 54.05C129.085 54.05 109.096 74.0391 109.096 98.7V112.8Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.796 256.15V232.65",
    stroke: "#1F76FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.096 112.8C109.096 137.461 129.085 157.45 153.746 157.45C178.407 157.45 198.396 137.461 198.396 112.8V98.7C198.396 74.0391 178.407 54.05 153.746 54.05C129.085 54.05 109.096 74.0391 109.096 98.7V112.8Z",
    stroke: "#1F76FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.896 235C221.896 197.362 191.384 166.85 153.746 166.85C116.108 166.85 85.5959 197.362 85.5959 235V256.15H221.896V235Z",
    stroke: "#1F76FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.746 314.9C247.746 318.792 211.974 321.95 167.846 321.95C123.718 321.95 87.9459 318.792 87.9459 314.9C87.9459 311.004 123.718 307.85 167.846 307.85C211.974 307.85 247.746 311.004 247.746 314.9Z",
    fill: "#1F76FF",
    fillOpacity: 0.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.204 247.792L172.939 224.527C169.269 220.861 163.318 220.861 159.648 224.527L149.679 234.5C146.004 238.171 146.004 244.121 149.679 247.792L192.881 290.994C196.552 294.67 202.502 294.67 206.173 290.994L287.652 209.52C291.323 205.849 291.323 199.899 287.652 196.228L277.679 186.255C274.008 182.584 268.058 182.584 264.387 186.255L202.85 247.792C201.017 249.63 198.042 249.63 196.204 247.792Z",
    fill: "#AECDFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.204 247.792L172.939 224.527C169.269 220.861 163.318 220.861 159.648 224.527L149.679 234.5C146.004 238.171 146.004 244.121 149.679 247.792L192.881 290.994C196.552 294.67 202.502 294.67 206.173 290.994L287.652 209.52C291.323 205.849 291.323 199.899 287.652 196.228L277.679 186.255C274.008 182.584 268.058 182.584 264.387 186.255L202.85 247.792C201.017 249.63 198.042 249.63 196.204 247.792Z",
    stroke: "#1F76FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserApproveCheck);
export default __webpack_public_path__ + "static/media/user-approve-check.25cce820e3595a372602596fba2a4cd2.svg";
export { ForwardRef as ReactComponent };